import { observer } from 'mobx-react-lite'
import { ApplicantManagementPanel } from '@/features/admin/staffing/components/ApplicantManagementPanel'
import { ApplicantManagementTableContainer } from '@/features/admin/staffing/components/ApplicantManagementTable/ApplicantManagementTableContainer'
import { type ApplicantManagementPanelViewModel } from './ApplicantManagementPanelViewModel'

export interface ApplicantManagementPanelContainerProps {
  vm: ApplicantManagementPanelViewModel
}

export const ApplicantManagementPanelContainer = observer(
  function ApplicantManagementPanelContainer({
    vm,
  }: ApplicantManagementPanelContainerProps) {
    const workspace = vm.workspacePosting?.workspace

    return (
      <ApplicantManagementPanel
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        postingId={vm.workspacePosting?.id}
        workspaceName={workspace?.name}
        workspaceIcon={workspace?.branding.logos.icon}
        totalApplicants={vm.workspacePosting?.applicants.length}
        searchText={vm.searchText.value}
        onSearchTextChange={vm.searchText.change}
        onInviteSelected={vm.inviteSelected}
        isInviteSelectedDisabled={!vm.canInviteSelected}
        onRescindSelected={vm.rescindInvitationForSelected}
        isRescindSelectedDisabled={vm.selectedApplicants.size < 1}
        onExportCsv={vm.exportApplicantsAsCSV}
      >
        <ApplicantManagementTableContainer vm={vm} />
      </ApplicantManagementPanel>
    )
  },
)
